'use client';

import { motion } from 'motion/react';
import { MonitorSmartphone, BarChart3, Wallet } from 'lucide-react';

export default function Ecosystem() {
  const features = [
    {
      icon: <MonitorSmartphone size={20} className="text-[#b4ff00]" />,
      title: "Unified Branding",
      desc: "Push visual identity updates across all federation and competition websites from a single org dashboard."
    },
    {
      icon: <BarChart3 size={20} className="text-[#b4ff00]" />,
      title: "Global Analytics",
      desc: "Aggregate player data and participation metrics from every level into a master executive report."
    },
    {
      icon: <Wallet size={20} className="text-[#b4ff00]" />,
      title: "Smart Monetization",
      desc: "Manage complex revenue share models between Organizations and their sub-federations automatically."
    }
  ];

  return (
    <section className="bg-[#0f0f0f] py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-4 text-3xl font-black tracking-tight text-white md:text-4xl"
          >
            Unified Ecosystem
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-sm text-zinc-400"
          >
            The power of one platform, everywhere.
          </motion.p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="rounded-lg border border-zinc-800 bg-[#141414] p-8"
            >
              <div className="mb-6 flex h-10 w-10 items-center justify-center rounded bg-zinc-900 border border-zinc-800">
                {feature.icon}
              </div>
              <h3 className="mb-4 text-lg font-bold text-white">{feature.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
